import http from "./httpservices";
import jwtDecode from "jwt-decode";

const apiEndpoint = "auth/login/";
const tokenKey = process.env.REACT_APP_TOKEN_NAME;

//login function
export async function login(credentials) {
  const listOfDomains = ["idiotic.media"];

  if (listOfDomains.indexOf(credentials.email.split("@")[1]) < 0) {
    return false;
  }

  try {
    const { data: token } = await http.post(apiEndpoint, credentials);
    const user = jwtDecode(token);

    localStorage.setItem(tokenKey, token);
    localStorage.setItem("username", user.name);
    http.setToken(token);

    return true;
  } catch (error) {
    return false;
  }
}

// Forgot Password - Send OTP
export async function sendOtp(email) {
  try {
    await http.post("auth/forgot-password", { email });
    localStorage.setItem("resetEmail", email); // Store email temporarily
    return { success: true, message: "OTP sent successfully." };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || "Failed to send OTP." };
  }
}

// Verify OTP
export async function verifyOtp(email, otp) {
  try {
    await http.post("auth/verify-otp", { email, otp });
    return { success: true, message: "OTP verified successfully." };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || "Invalid OTP." };
  }
}

// Reset Password
export async function resetPassword(email, newPassword) {
  try {
    await http.post("auth/reset-password", { email, newPassword });
    localStorage.removeItem("resetEmail"); // Clear stored email after reset
    return { success: true, message: "Password reset successful. You can now log in." };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || "Failed to reset password." };
  }
}

export function getToken() {
  const token = localStorage.getItem(tokenKey);
  if (token) {
    return token;
  } else {
    return null;
  }
}

export function getLocalStorage(name) {
  const result = localStorage.getItem(name);
  if (result) {
    return result;
  } else {
    return null;
  }
}

export function getLocalStorageObj() {
  return {
    user_id: getLocalStorage("id"),
    token: getLocalStorage(tokenKey),
    profile_id: getLocalStorage("profile_id"),
  };
}

export function getApiPath() {
  return process.env.REACT_APP_API_URL;
}

export default {
  login,
  sendOtp,
  verifyOtp,
  resetPassword,
  getToken,
  getApiPath,
  getLocalStorage,
  getLocalStorageObj,
};
